import React from 'react';
import DayPicker from 'react-day-picker';

import localeUtils from './localeUtils';

import 'react-day-picker/lib/style.css';
import './style.scss';

export default props => <DayPicker localeUtils={localeUtils} {...props} />;
